import { Injectable, Injector } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { CurrentUser } from '../../security/current-user.model';
import { VERSION } from "../../../environments/version";
import { ErrorInfo, ErrorInfoList, ErrorCodes } from '../../error/error-info';
import 'rxjs/add/operator/toPromise';

import { AppConfig, Facet, FacetValue, SearchResult, SearchCriteria, FacetRenderMode, AppBuildInfo, Preset, FacetSearchCriteria } from './faceted-search-app.model';
import { CurrentUserService } from '../../security/current-user.service';
import { MatDialog } from '@angular/material';
import { AuthFailDialogComponent } from '../../security/auth-fail-dialog/auth-fail-dialog.component';
import { Router } from '@angular/router';

@Injectable()
export class FacetedSearchAppService {
  private baseUrl = '';
  private searchUrl = '';
  private presetUrl = '';

  constructor(private http: Http, private currentUserService: CurrentUserService, private dialog: MatDialog, private router: Router) {
    this.baseUrl = currentUserService.loginSiteUrl + "api/ui/";
    this.searchUrl = currentUserService.loginSiteUrl + "api/search/";
    this.presetUrl = currentUserService.loginSiteUrl + "api/presets/";

    this.http.get(this.baseUrl + "isAdmin")
      .toPromise()
      .then(response => {
        var result = response.json();
        console.log("isAdminUser: " + result);
        this.isAdminUser = response.json();
      })
      .catch((error: Response) => {
        console.log("isAdminUser: error");
        return this.handleError(error);
      });
    this.refreshPresets();

  }

  appConfig: AppConfig;

  getAppConfig(): Promise<AppConfig> {
    return this.http.get(this.baseUrl + "appconfig")
      .toPromise()
      .then(response => {
        this.appConfig = response.json();
        return this.appConfig;
      })
      .catch((error: Response) => {
        return this.handleError(error); //"Can't get the API configuration at " + this.baseUrl;
      });
  }

  updateAppConfig(config: AppConfig): Promise<void> {
    let payload = JSON.stringify(config);
    console.log(payload);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.baseUrl + "appConfig", payload, options)
      .toPromise()
      .then(response => {
        this.appConfig = config;
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  public get appBuildInfo(): Promise<AppBuildInfo> {
    return this.http.get(this.baseUrl + "buildInfo")
      .toPromise()
      .then(response => {
        let abi = new AppBuildInfo();
        abi.apiBuildInfo = response.json();
        abi.webBuildInfo = VERSION;
        return abi;
      })
      .catch((error: Response) => {
        return this.handleError(error); //"Can't get the API configuration at " + this.baseUrl;
      });
  }



  facetRenderModes(): Promise<FacetRenderMode[]> {
    return this.http.get(this.baseUrl + "facetRenderModes")
      .toPromise()
      .then(response => {
        let renderModes = response.json();
        return renderModes;
      })
      .catch((error: Response) => {
        return this.handleError(error);
      });
  }

  facets(): Promise<Facet[]> {
    return this.http.get(this.baseUrl + "facets")
      .toPromise()
      .then(response => {
        var facets: Facet[];
        facets = response.json();
        return facets;
      })
      .catch((error: Response) => {
        return this.handleError(error);
      });
  }

  updateFacets(facets: Facet[]): Promise<void> {
    let payload = JSON.stringify(facets);
    console.log("updateFacets");
    //console.log(payload);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.baseUrl + "facets", payload, options)
      .toPromise()
      .then(response => {
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  facetValues(facetId: number): Promise<FacetValue[]> {
    return this.http.get(this.baseUrl + "facetvalues/" + facetId.toString())
      .toPromise()
      .then(response => {
        let facetValue: FacetValue[] = response.json();
        return facetValue;
      })
      .catch((error: Response) => {
        return this.handleError(error);
      });
  }

  currentSearchCriteria: SearchCriteria = new SearchCriteria();
  currentSearchResults: SearchResult[] = new Array();

  public currentSearchCriteriaForFacet(facetId: number): FacetSearchCriteria {
    if (this.currentSearchCriteria.has(facetId)) {
      return this.currentSearchCriteria.keyValue(facetId);
    }
    return null;
  }

  // the query that's formulated here works like this:
  // for each facet, "or" the given facet value ids  e.g. "13,14,16", separated by commas
  // then "and" the groups together, separated by semicolons, e.g., "13,14,16;22,24"
  // note: we only need to deal in facet value IDs, not facet IDs, because there each facet value ID
  // uniquely determines one facet ID.


  search(): Promise<SearchResult[]> {
    //this.currentSearchCriteria = criteria;
    let facetQuery: string = this.currentSearchCriteria.toFacetQueryString();
    return this.http.get(this.searchUrl + "searchfor?text=" + encodeURIComponent(this.currentSearchCriteria.text) + "&facetQuery=" + encodeURIComponent(facetQuery))
      .toPromise()
      .then(response => {
        this.currentSearchResults = response.json();
        console.log(this.currentSearchResults);
        return this.currentSearchResults;
      })
      .catch((error: Response) => {
        return this.handleError(error);
      });
  }


  // Presets: saving, updating, reordering, deleting

  presets: Preset[] = [];

  saveSearch(searchName: string): Promise<void> {
    let preset = new Preset()
    preset.presetName = searchName;
    preset.presetValue = this.currentSearchCriteria.toString();
    let payload = JSON.stringify(preset);
    console.log("saveSearch");
    //console.log(payload);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.presetUrl + "savebyname", payload, options)
      .toPromise()
      .then(response => {
        this.refreshPresets();
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  refreshPresets(): Promise<void> {
    return this.http.get(this.presetUrl)
      .toPromise()
      .then(response => {
        this.presets = response.json();
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  updatePresets(): Promise<void> {
    let payload = JSON.stringify(this.presets);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.presetUrl, payload, options)
      .toPromise()
      .then(response => {
        this.refreshPresets(); // in case someone else did this at the same time?
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  updatePreset(updatedPreset: Preset): Promise<void> {
    let payload = JSON.stringify(updatedPreset);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.presetUrl + "savebyid", payload, options)
      .toPromise()
      .then(response => {
        this.refreshPresets(); // in case someone else did this at the same time?
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  deletePreset(presetId: number): Promise<void> {
    let payload = JSON.stringify(presetId);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(this.presetUrl + "delete/" + presetId.toString())
      .toPromise()
      .then(response => {
        this.refreshPresets();
        return;
      })
      .catch((error: Response) => {
        this.handleError(error);
        return;
      });
  }

  private handleError(error: any): Promise<any> {
    if (error.status && error.status == 401 && this.currentUserService.user != null) {
      this.errorDialog("You are not authenticated.");
      //localStorage.setItem(ErrorCodes.Key, error.status);
    }
    else {
      localStorage.setItem(ErrorCodes.Key, error.status || ErrorCodes.UnexpectedError);
      this.router.navigate(['/error']);
    }
    return Promise.reject(error.message || error);
  }

  errorDialog(error: any): void {
    let dialogRef = this.dialog.open(AuthFailDialogComponent, {
      width: '400px',
      data: { error: error },
    });
  }

  public isAdminUser: boolean;


  public initialize(): void {

  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/webapi/faceted-search-app.service.ts